var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.data)?_c('form-component',{attrs:{"data":_vm.data},on:{"submit":_vm.onSubmit}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }